import { useEffect, useState } from 'react';

/** Match a CSS media query; returns false during SSR/no-matchMedia. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    // Note: we intentionally do not call setMatches(mql.matches) here.
    // The lazy useState initializer already captured the match at mount;
    // the change listener handles subsequent media-query events.
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** True when the viewport is desktop/tablet width (≥ 768px). */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 768px)');
}
